import React, { SVGProps } from 'react';

export function RemixIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="45"
      height="50"
      viewBox="0 0 45 50"
      fill="var(--primaryTextColor)"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.1922 37.4218C40.5993 42.735 40.5993 45.2256 40.5993 47.9444H28.4981C28.4981 47.3522 28.5086 46.8105 28.5191 46.2612C28.5518 44.5535 28.586 42.7728 28.3136 39.1768C27.9537 33.912 25.722 32.7421 21.6185 32.7421H17.9829H2.58594V23.1633H22.1945C27.3777 23.1633 29.9695 21.5615 29.9695 17.3204C29.9695 13.5913 27.3777 11.3314 22.1945 11.3314H2.58594V1.95825H24.3542C36.0886 1.95825 41.9199 7.58859 41.9199 16.5824C41.9199 23.3095 37.8165 27.6968 32.2731 28.428C36.9525 29.3785 39.6882 32.084 40.1922 37.4218Z"
      />
      <path d="M2.58594 47.9444V40.8037H15.3812C17.5184 40.8037 17.9825 42.414 17.9825 43.3744V47.9444H2.58594Z" />
    </svg>
  );
}
export default RemixIcon;
